@if (report$ | async; as report) {
  <div id="reportContainer">
    <powerbi-report
      [embedConfig]="report.embedConfiguration"
      [cssClassName]="reportClass">
    </powerbi-report>
  </div>
} @else if (isLoaded$ | async) {
  <div class="not-found">
    <p>Report not found.</p>
  </div>
}
